export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./phone-number-provider.vue?vue&type=template&id=dd006524"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/payments/phone-number-provider.vue?vue&type=template&id=dd006524
// module id = +u4y
// module chunks = 0